module.exports = __webpack_public_path__ + "static/media/hakimg.3c7ca898.png";